<ng-template #compContent>
  <div class="bpx-container" *ngIf="baseProduct">
    <h3 class="text-center">{{baseProduct?.name}} [{{baseProduct?.trial}}]</h3>
    <p><b>Issuer: {{issuerData.get(issuer)?.name}}</b></p>
    <table class="nrk-table">
      <tr>
        <!-- <th *ngFor="let col of tableConfig"><i>{{col.header || ''}}</i></th> -->
        <th *ngIf="fromOfferTemplate"></th><th></th><th></th><th colspan="7">Selling price</th><th colspan="8">Buying price</th>
      </tr>
      <tr>
        <th *ngIf="fromOfferTemplate"></th>
        <th *ngFor="let col of tableConfig" class="pseudo-link" (click)="sortRows(col)">{{sort.col === col.id ? ( sort.dir === 1 ? '▼  ' : '▲  ') + col.name : col.name || ''}}</th><th></th>
      </tr>
      <tr *ngFor="let line of rows; index as idx">
        <td *ngIf="fromOfferTemplate"><ngx-doc-form-checkbox [(value)]="line.checked" (valueChange)="itemsChanged()"></ngx-doc-form-checkbox></td>
        <ng-container *ngFor="let col of tableConfig">

          <td *ngIf="!col.edit && !col.options" [ngStyle]="col.style">
            {{line[col.id]}}
          </td>

          <td *ngIf="col.edit === 'number'" [ngStyle]="col.style">
            <div *ngIf="(!fromWizard || fromWizard.offerWizard) && col.wizardOnly; else showTextfield">n/a</div>
            <ng-template #showTextfield>
              <ngx-doc-form-texfield class="fullwidth right" [(value)]="line[col.id]" (valueChange)="rowChanged(line, col, idx)"></ngx-doc-form-texfield>
            </ng-template>
          </td>

          <td *ngIf="col.edit === 'date'" [ngStyle]="col.style">
            <ngx-doc-form-date class="fullwidth" [(value)]="line[col.id]" (valueChange)="rowChanged(line, col, idx)"></ngx-doc-form-date>
          </td>

          <td *ngIf="col.options" [ngStyle]="col.style">
            <ngx-doc-form-dropdown class="fullwidth" [(value)]="line[col.id]" (valueChange)="rowChanged(line, col, idx)" [options]="col.options"></ngx-doc-form-dropdown>
          </td>

        </ng-container>
        <td *ngIf="line.changed"><b>✓</b></td>
        <td *ngIf="!line.changed"></td>
      </tr>
    </table>
  </div>
</ng-template>


<ng-container *ngIf="!fromWizard">
  <ng-container *ngTemplateOutlet="compContent"></ng-container>
  <div class="text-center" *ngIf="rows?.length">
    <button class="btn btn-md btn-primary" title="add base product" (click)="save()">
      Save matrix
    </button>
  </div>
</ng-container>

<ng-sidebar-container *ngIf="fromWizard">
  <div ng-sidebar-content>
  <ngx-page-container>
    <ng-container *ngTemplateOutlet="compContent"></ng-container>
  </ngx-page-container>
</div>
</ng-sidebar-container>


<div class="nrk-wizard-footer text-center" *ngIf="fromWizard">

  <ng-container *ngIf="fromWizard.offerWizard">
    <button class="btn btn-md btn-primary" title="add finished products" (click)="save()">
      Save matrix
    </button>
  </ng-container>

  <ng-container *ngIf="fromWizard.productWizard">
    <button class="btn btn-md btn-default" title="back to base product" 
      (click)="gotoBaseProduct(baseProduct)">
      <i class="ion-arrow-left-a"></i>
    </button>

    <button class="btn btn-md btn-primary" title="add base product" (click)="save()">
      Save matrix
    </button>

    <!-- <button *ngIf="fromWizard" class="btn btn-md btn-info" title="go to finished products" (click)="newFinishedProductWizard(null)">
      New finished product
    </button> -->

    <button class="btn btn-info btn-md" (click)="genLineItemsFromFinishedProducts()" 
      title="generate line items from base product's finished products">
      Gen line items
    </button>


    <button class="btn btn-md btn-default" [title]="finishedProducts?.length ? 'go to finished product' : 'new finished product'" 
      (click)="finishedProducts?.length ? gotoFinishedProduct(finishedProducts[0]) : newFinishedProductWizard(baseProduct)">
      <i class="ion-arrow-right-a"></i>
    </button>
  </ng-container>

</div>